import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { LocationsMapWrapperV2 } from 'views/rebranded-module/location-module/LocationsViewV2/components';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  '& .LVHeader': {
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(4, 0),
  },
}));
export const StyledLocationsMapWrapperV2 = styled(LocationsMapWrapperV2)(
  () => ({
    height: '65vh',
  }),
);
export default StyledBox;
